import React from 'react'
import styled from 'styled-components'
import {Error} from '@mui/icons-material'

const Alert = styled.div`
    color: #d45b4a;
    background-color: rgb(253, 236, 234);
    padding: 10px;
    margin-bottom: 20px;
    line-height: 20px;

    div {
        display: flex;
        align-items: center;
    }
`

export default ({text, children}) => {
    return (
        <Alert>
            <div>
                <Error style={{marginRight: '10px'}}/>
                {text}
            </div>
            {children}
        </Alert>
    )
}
